































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import Assets from '@/constants/assets';
import RouteNames from '@/constants/route-names';

import Button, { ButtonSize } from '@/modules/shared/components/button.component.vue';
import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';

import UtilsService from '@/modules/core/services/utils.service';

@Component({
  components: {
    Button,
    Icon,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      catalogUrls: 'getCatalogUrls',
      hasFidelizationAccess: 'hasFidelizationAccess',
    }),
  },
  methods: {
    ...mapActions({
      getCatalogUrls: 'getCatalogUrls',
    }),
  },
})
export default class MainNavBar extends Vue {
  private assets = Assets;
  private buttonSize = ButtonSize;
  private iconEnum = IconEnum;
  private utilsService = UtilsService;
  private routeNames = RouteNames;
  private menuIsOpen: boolean = false;
  private isAuthenticated!: boolean;
  private catalogUrls!: any;
  private getCatalogUrls!: any;
  private hasFidelizationAccess!: any;
  private topButtonBasicVisibility = false;
  private topButtonProVisibility = false;

  private created() {
    this.buttonTopVisibility();
    this.getCatalogUrls();
  }

  private updated() {
    this.buttonTopVisibility();
  }

  get catalogVisibillity() {
    return true;
  }

  get ratesVisibillity() {
    return this.isAuthenticated;
  }

  get ecotrBasicVisibility() {
    return !this.isAuthenticated;
  }

  get ecotrProVisibility() {
    return this.isAuthenticated;
  }

  get ecoCloudVisibility() {
    return this.isAuthenticated;
  }

  get ecoLoyaltyVisibility() {
    return this.isAuthenticated && this.hasFidelizationAccess;
  }

  get ecoSalesVisibility() {
    return this.isAuthenticated && this.hasFidelizationAccess;
  }

  get profileVisibility() {
    return this.isAuthenticated;
  }

  get backVisibility() {
    return !this.isAuthenticated;
  }

  get signupVisibillity() {
    return !this.isAuthenticated;
  }

  get menu() {
    return {
      basic: this.ecotrBasicVisibility,
      pro: this.ecotrProVisibility,
      ecoTrBasic: this.ecotrProVisibility,
      catalog: this.catalogVisibillity,
      rates: this.ratesVisibillity,
      ecoCloud: this.ecoCloudVisibility,
      ecoLoyalty: this.ecoLoyaltyVisibility,
      ecoSales: this.ecoSalesVisibility,
      profile: this.profileVisibility,
      signup: this.signupVisibillity,
      styleGuide: this.showStyleGuide,
    };
  }

  get outButtonVisibility() {
    return this.isAuthenticated;
  }

  private buttonTopVisibility() {
    const routeName = this.$router.currentRoute.name;
    if ( routeName === RouteNames.ecoTrBasic ) {
      this.topButtonProVisibility = true;
      this.topButtonBasicVisibility = false;
    } else if ( routeName === RouteNames.studyPro) {
      this.topButtonProVisibility = false;
      this.topButtonBasicVisibility = true;
    } else {
      this.topButtonProVisibility = false;
      this.topButtonBasicVisibility = false;
    }
  }
  private showMenu(): void {
    this.menuIsOpen = true;
  }

  private hideMenu(): void {
    this.menuIsOpen = false;
  }

  private goToCatalog() {
    let url = this.catalogUrls.linkToCatalog;
    if ( UtilsService.getCookie('mobile-device') !== null) {
        url = `${url}@download@`;
        window.location = url;
    } else {
        window.open(url, '_blank');
    }
  }

  private goToRates() {
    let url = this.catalogUrls.linkToRates;
    if ( UtilsService.getCookie('mobile-device') !== null) {
        url = `${url}@download@`;
        window.location = url;
    } else {
        window.open(url, '_blank');
    }
  }

  private goToSignup() {
    this.$router.push({ name: 'signup' });
  }

  private logout() {
    this.$store.dispatch('authLogout')
    .then(() => {
      this.$router.push({ name: 'login' });
    });
  }

  private goToBasicStudy() {
    this.topButtonProVisibility = true;
    this.topButtonBasicVisibility = false;
    this.$router.push({ name: RouteNames.ecoTrBasic });
  }

  private goToProStudy() {
    this.topButtonProVisibility = false;
    this.topButtonBasicVisibility = true;
    this.$router.push({ name: RouteNames.studyPro });
  }

  private login() {
    this.$router.push({ name: 'login' });
  }

  get showStyleGuide(): boolean {
    return this.utilsService.inDebug();
  }

  @Watch('$route')
  private onRouteChange(newVal: string, oldVal: string) {
    this.hideMenu();
  }

}
